import { useRef, useEffect, useState } from "react";
import AnnouncementCard from "../../AnnouncementCard";
import { HomeSectionLayout } from "../../../components/HomeSectionLayout";
import { useScreenSize } from "../../../hooks/useScreenSize";

export default function TimeSection({
  announcements
}: any) {
  const calendarFrameRef = useRef<HTMLDivElement>(null)
  const [calendarDimensions, setCalendarDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const updateDimensions = () => {
      if (calendarFrameRef.current) {
        setCalendarDimensions({
          width: calendarFrameRef.current.offsetWidth,
          height: calendarFrameRef.current.offsetHeight
        })
      }
    }

    updateDimensions()
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const { isSmall } = useScreenSize()

  return (
    <HomeSectionLayout.Container style={{
      backgroundColor: 'var(--color-base-100)',
      color: 'var(--color-neutral)',
    }}>
      <HomeSectionLayout.Content style={{
        display: 'flex',
        flexDirection: isSmall ? 'column' : 'row',
      }}>
        {announcements.length > 0 && (
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
          }}>
            <h1 className="text-4xl font-bold">
              Annonces
            </h1>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              height: isSmall ? 'auto' : '400px',
              overflowY: 'auto',
            }}>
              {announcements.map((announcement: any) => (
                <AnnouncementCard
                  key={`announcement-card-${announcement.id}`}
                  announcement={announcement}
                />
              ))}
            </div>
          </div>
        )}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '5px',
        }}>
          <h1 className="text-4xl font-bold">
            Calendrier
          </h1>
          <div
            ref={calendarFrameRef}
            style={{
              width: '100%',
              height: '400px',
            }}
          >
            {calendarDimensions.width > 0 && (
              <iframe
                src="https://calendar.google.com/calendar/embed?src=3eca8543cc46a40dcc1f3b8f64bce471ade25b51c0bfe5b3a07cc42e6a947229%40group.calendar.google.com&ctz=America%2FNipigon&mode=AGENDA"
                style={{
                  border: 0
                }}
                width={calendarDimensions.width}
                height={calendarDimensions.height}
              />
            )}
          </div>
        </div>
      </HomeSectionLayout.Content>
    </HomeSectionLayout.Container>
  )
}
